window.Alpine.start(); // TODO: Move down if modules missing.
